import { UnitsType } from "@/types/settings/units";
import { UnitsInterface } from "@/interface/business/units.interface";
import { PermissionsConstrains } from "@/enums/permissions.enum";

class Units implements UnitsInterface {
  id: string = "";
  name: string = "";
  abbreviation: string = "";
  is_system: boolean = false;

  public static module_name = PermissionsConstrains.UNITS;

  constructor(data?: UnitsType) {
    if (data) {
      this.id = data.id || "";
      this.name = data.name || "";
      this.abbreviation = data.abbreviation || "";
      this.is_system = data.is_system || false;
    }
  }
}

export default Units;
